module.exports = __webpack_public_path__ + "static/11-8f040ff66a48728f7282b29b98362a38.png";